module.exports = __webpack_public_path__ + "media/images/common/menu_bottoms_ov-20754d3852f02c144bb5991b68300450.gif";